import {
  SubscriptionUpgradeResponse,
  VenueGetSubscriptionUpgradeCostInput,
} from '../../graphql/API';
import { venueGetSubscriptionUpgradeCost } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const venueGetSubscriptionUpgradeCostApi = async (
  input: VenueGetSubscriptionUpgradeCostInput,
): Promise<SubscriptionUpgradeResponse> => {
  const result = await executeGql(venueGetSubscriptionUpgradeCost, { input });
  return processGqlResult<SubscriptionUpgradeResponse>('venueGetSubscriptionUpgradeCost', result);
};
